export var DataType;
(function (DataType) {
    DataType["BOOLEAN"] = "BOOLEAN";
    DataType["INTEGER"] = "INTEGER";
    DataType["FLOAT"] = "FLOAT";
    DataType["NUMBER"] = "NUMBER";
    DataType["DATE"] = "DATE";
    DataType["DATETIME"] = "DATETIME";
    DataType["DATEWKDAY"] = "DATEWKDAY";
    DataType["DATEMONTH"] = "DATEMONTH";
    DataType["DATEQTR"] = "DATEQTR";
    DataType["STRING"] = "STRING";
    DataType["REGEXP"] = "REGEXP";
    DataType["NULL"] = "NULL";
    DataType["UNDEFINED"] = "UNDEFINED";
})(DataType || (DataType = {}));
